import {Base} from "@/api/Base"

export class EmployeeEntryRecordEdit extends Base {
    path = "employeeEntryRecord/edit"
}